export default __webpack_public_path__ + "static/media/02.a529b0db.jpg";